import React, { useEffect } from "react";
import type { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge";
import { useTheme } from "styled-components";
import { updateStatusBarColor } from "utils/statusBar";

interface AppContentWrapperProps {
    children: React.ReactNode;
    swiggyHeaders: GetSwiggyHeadersResponsePayload | undefined;
}

const AppContentWrapper: React.FC<AppContentWrapperProps> = ({ children, swiggyHeaders }) => {
    const { colors, colorMode } = useTheme();

    const androidStatusBarColor = colors[colorMode].background_Primary;
    const iosStatusBarColor = colorMode === "light" ? "default" : "lightContent";

    useEffect(() => {
        updateStatusBarColor(swiggyHeaders, androidStatusBarColor, iosStatusBarColor);
    }, [androidStatusBarColor, iosStatusBarColor, swiggyHeaders]);

    return <>{children}</>;
};

export default AppContentWrapper;
